
import Vue from "vue";
import { Line } from "vue-chartjs";

export default Vue.extend({
    extends: Line,
    data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                            },
                        },
                    ],
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                            },
                        },
                    ],
                },
            },
        };
    },
    props: {
        datasets: Array,
        labels: Array,
    },
    computed: {
        chartdata() {
            return {
                labels: this.labels,
                datasets: this.datasets,
            };
        },
    },
    methods: {
        renderChartMethod() {
            this.renderChart(this.chartdata, this.options);
        },
    },
    mounted() {
        this.renderChartMethod();
    },
});
